import { getErrorMessage } from "./errors" // Use explicit import - urlContainsHost is used in nuxt.config, which doesn't support auto-imports

export const urlContainsHost = (url: string, hosts: Array<string>): boolean => {
  try {
    const parsedUrl = new URL(url)
    return hosts.includes(parsedUrl.hostname) || hosts.some((host) => parsedUrl.hostname.endsWith(`.${host}`))
  } catch (e) {
    const errorMessage = getErrorMessage(e)
    console.error("Error parsing URL:", errorMessage)

    return false
  }
}
